import { Dialog } from "@headlessui/react";
import { useEffect, useMemo, useState } from "react";
import Button from "../basic/Button";
import ic_close from "../../assets/icons/ic_close.svg";
import IconButton from "../basic/IconButton";
import {
  addMultipleExercisesToPlaylist,
  createUserPlaylist,
  getUserPlaylist,
} from "../../api/api";
import { toast } from "react-toastify";
import CustomDialog from "../basic/Dialog";
import {
  BlackTextLinearGradient,
  BlueLinearGradient,
  WhiteLinearGradient,
  WhiteTextLinearGradient,
} from "../../utils/Utils";
import { Icon } from "@iconify/react";

function AddToPlaylistDialog({
  exerciseIdList,
  open,
  close,
  onUserPlaylistUpdate,
}) {
  const [createNewPlaylist, setCreateNewPlaylist] = useState(false);
  const [search, setSearch] = useState("");

  const [playlist, setPlaylist] = useState([]);
  const searchList = useMemo(() => {
    if (search === "") return playlist;
    const list = playlist.filter((playlist) => {
      return playlist.playlistName.toLowerCase().includes(search.toLowerCase());
    });    
    if (list.length === 0) {
      toast("No Playlist found with name '" + search + "'");
    }
    return list;
  }, [playlist, search]);

  const [playlistName, setPlaylistName] = useState("");

  async function createPlaylist() {
    const response = await createUserPlaylist(playlistName);
    if (response.success) {
      toast("Playlist Created", { type: "success" });
      addToPlaylist(response.playlistName);
      onUserPlaylistUpdate();
      setCreateNewPlaylist(false);
      close();
    } else {
      toast("Error creating playlist", { type: "error" });
    }
  }

  async function fetchPlaylists() {
    const response = await getUserPlaylist();
    setPlaylist(response);
  }
  async function addToPlaylist(playlistId) {
    const response = await addMultipleExercisesToPlaylist(
      playlistId,
      JSON.stringify(exerciseIdList)
    );
    if (response.success) {
      toast(
        `${
          exerciseIdList.length > 1 ? "Exercises" : "Exercise"
        } Added successfully`,
        { type: "success" }
      );
      onUserPlaylistUpdate();
      close();
    } else {
      toast("Exercise Addition failed", { type: "error" });
    }
  }

  useEffect(() => {
    if (open) fetchPlaylists();
    return () => {
      setSearch("");
      setPlaylistName("");
    };
  }, [open]);

  return (
    <CustomDialog
      show={open}
      close={() => {
        setCreateNewPlaylist(false);
        close();
      }}
    >
      <Dialog.Panel
        className={`w-full max-w-md transform overflow-hidden rounded-2xl ${WhiteLinearGradient} p-6 text-left align-middle shadow-xl transition-all`}
      >
        <div className="w-full flex justify-center items-center">
          <p
            className={` font-medium text-xl text-primary-black dark:text-primary-white flex flex-1 text-center w-full `}
          >
            {createNewPlaylist ? "Create a new Playlist" : "Add to Playlist"}
          </p>
          <IconButton
            icon={ic_close}
            className="shadow-xl "
            onClick={() => {
              close();
              setCreateNewPlaylist(false);
            }}
          />
        </div>
        {createNewPlaylist ? (
          <div>
            <input
              value={playlistName}
              className={`mt-3 px-4 py-3 rounded-lg border-[1px] border-gray-300 w-full ${WhiteLinearGradient} text-black dark:text-white`}
              placeholder="Playlist Name"
              onChange={(e) => {
                setPlaylistName(e.target.value);
              }}
            />
            <div className="w-full flex justify-end">
              <Button
                type={"outline"}
                className="border-black mt-5 "
                onClick={() => {
                  if (playlistName.length == 0) {
                    toast("Playlist name is required", { type: "error" });
                  } else {
                    createPlaylist();
                  }
                }}
              >
                Create
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <input
              value={search}
              className="mt-3 px-4 py-3 bg-transparent border-b-[1px] placeholder:text-primary-gray border-gray-300 w-full text-black dark:text-white"
              placeholder="Search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <div className="-mx-6">
              {searchList.map((playlist, index) => {
                return (
                  <div
                    className="flex flex-row w-full py-3 space-x-5 items-center px-6 cursor-pointer hover:bg-primary-extraLightBlue"
                    onClick={() => {
                      addToPlaylist(playlist.playlistId);
                    }}
                    key={index}
                  >
                    <div
                      className={`${BlueLinearGradient} rounded-full h-8 w-8 flex items-center justify-center`}
                    >
                      <p
                        className={`font-medium text-lg ${WhiteTextLinearGradient}`}
                      >
                        {playlist.playlistName[0]}
                      </p>
                    </div>
                    <p className={`${BlackTextLinearGradient}`}>
                      {playlist.playlistName}
                    </p>
                  </div>
                );
              })}

              <div
                className="flex flex-row w-full py-3 px-6  space-x-5 items-center  cursor-pointer hover:bg-primary-extraLightBlue"
                onClick={() => {
                  setCreateNewPlaylist(true);
                }}
              >
                <div
                  className={`${BlueLinearGradient} rounded-full h-8 w-8 flex items-center justify-center`}
                >
                  <Icon icon="akar-icons:plus" color="#fff" />
                </div>
                <p className={`${BlackTextLinearGradient}`}>
                  Create a new playlist
                </p>
              </div>
            </div>
          </div>
        )}
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default AddToPlaylistDialog;
